

<template>
    <Breadcrumbs main="Bonus Ui" title="Tour" />
    <div class="container-fluid">
        <div class="user-profile">
            <userProfile />
        </div>
    </div>
</template>
  
<script lang="ts" setup>

import { ref, defineAsyncComponent, onMounted } from 'vue';
const userProfile = defineAsyncComponent(() => import("@/components/theme/advance/tour/userProfile.vue"))

</script>